import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function ImageBarcodeSearch() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Retrieve the API key from environment variables
  const apiKey = process.env.REACT_APP_FOODGYDE_API_KEY;

  const handleFileChange = (event) => {
    // ... (your existing file change logic) ...
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setMessage('');
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(null);
      setPreview(null);
    }
  };

  const handleUploadAndSearch = async () => {
    if (!selectedFile) {
      setMessage('Please select an image file first.');
      return;
    }

    const formData = new FormData();
    formData.append('barcodeImage', selectedFile);

    setIsLoading(true);
    setMessage('Processing image...');

    try {
      const response = await axios.post('https://api.foodgyde.com/search-by-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-API-Key': apiKey // <<< ADD THIS LINE with your API key variable
        },
      });

      setIsLoading(false);
      if (response.data && response.data.itemId) {
        setMessage(`Barcode found: ${response.data.barcode}. Navigating to item...`);
        navigate(`/item/${response.data.itemId}`);
      } else if (response.data && response.data.error) {
        setMessage(`Search by image: ${response.data.error} (Detected: ${response.data.barcode || 'N/A'})`);
      } else {
        setMessage('Barcode not recognized or item not found.');
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Error uploading image or searching by barcode:', error.response || error.message || error);
      if (error.response && error.response.data && error.response.data.error) {
        // Check for specific 403 from API key middleware
        if (error.response.status === 403) {
             setMessage(`Error: Access Denied. Please check API Key configuration.`);
        } else {
             setMessage(`Error: ${error.response.data.error}`);
        }
      } else {
        setMessage('Failed to process image due to a server or network error. Please try again.');
      }
    }
  };

  return (
    // ... (your existing JSX) ...
    <div className="mt-6 p-4 border border-gray-300 rounded-md shadow">
      <h3 className="text-lg font-semibold mb-3">Search by Barcode Image</h3>
      <input 
        type="file" 
        accept="image/*" 
        onChange={handleFileChange} 
        className="block w-full text-sm text-slate-500
                   file:mr-4 file:py-2 file:px-4
                   file:rounded-full file:border-0
                   file:text-sm file:font-semibold
                   file:bg-blue-50 file:text-blue-700
                   hover:file:bg-blue-100 mb-3"
      />
      {preview && (
        <div className="mb-3">
          <p className="text-sm font-medium">Preview:</p>
          <img src={preview} alt="Selected barcode" style={{ maxHeight: '150px', border: '1px solid #ddd', padding: '2px' }} />
        </div>
      )}
      <button 
        onClick={handleUploadAndSearch} 
        disabled={!selectedFile || isLoading}
        className="w-full px-6 py-3 bg-green-600 text-white rounded-md shadow hover:bg-green-700 disabled:opacity-50"
      >
        {isLoading ? 'Processing...' : 'Upload and Search by Image'}
      </button>
      {message && <p className={`mt-3 text-sm ${message.toLowerCase().includes('error') || message.toLowerCase().includes('failed') ? 'text-red-600' : 'text-green-600'}`}>{message}</p>}
    </div>
  );
}

export default ImageBarcodeSearch;